import { isEmpty } from 'lodash'
import { PAYMENT_CONTINGENCY_ACTIONS } from '../../../../../lib/constants'
import { setIsLoading } from '../Actions'
import { setScamResolvers } from './paymentContingencyActions'
import {
  openScamWarningOverpanel,
  setScamWarningType,
  openPurposeOfPaymentOverpanel,
  populatePurposeOfPaymentDetails,
} from './paymentContingencyDispatchers'
import * as ContingencyUtils from '../../utils/contingencyUtils'

/**
 * This handlers dispatch actions for unresolved contingencies. For example, a confirmation
 * overpanel when for a Scam Warning. Each handler returns a promise that can be used
 * to halt the transaction until customer chooses to continue.
 */
export function getPaymentContingencyHandlers(paymentContingencies) {
  return {
    [PAYMENT_CONTINGENCY_ACTIONS.DISPLAY_SCAM_WARNING]: () => {
      return (dispatch, getState) => {
        dispatch(setIsLoading(false))
        dispatch(setScamWarningType(paymentContingencies))

        return new Promise((resolve, reject) => {
          dispatch(setScamResolvers({ resolve, reject }))
          dispatch(openScamWarningOverpanel())
        })
      }
    },
    [PAYMENT_CONTINGENCY_ACTIONS.PURPOSE_CODE_COLLECTION_REQUIRED]: () => {
      return (dispatch, getState) => {
        const {
          transaction: { selectedPurposeOfPaymentOption } = {},
        } = getState()
        const contingency = ContingencyUtils.getPurposeCodeCollectionContingency(
          paymentContingencies
        )
        return handlePurposeCodeContingency(
          dispatch,
          contingency,
          selectedPurposeOfPaymentOption
        )
      }
    },
    // To be implemented
    [PAYMENT_CONTINGENCY_ACTIONS.PURCHASE_CONSENT_REQUIRED]: undefined,
    [PAYMENT_CONTINGENCY_ACTIONS.USER_AGREEMENT_CONSENT_REQUIRED]: undefined,
    [PAYMENT_CONTINGENCY_ACTIONS.SENDER_CIP_VERIFICATION_REQUIRED]: undefined,
  }
}

/**
 * handle the purpose code contingency logic.
 */
export function handlePurposeCodeContingency(
  dispatch,
  contingency,
  selectedPurposeOfPaymentOption
) {
  let selectedPurposeOfCode = ''
  if (contingency?.purposeCodeCollection) {
    if (contingency?.showPOPOverpanel) {
      populatePurposeOfPaymentDetails(dispatch, contingency, {})
      dispatch(setIsLoading(false))
      return dispatch(openPurposeOfPaymentOverpanel())
    } else if (
      contingency.selectedPurposeCode &&
      isEmpty(selectedPurposeOfPaymentOption)
    ) {
      if (contingency?.purposeCodeCollection?.supportedPurposeCodes) {
        selectedPurposeOfCode = contingency.purposeCodeCollection.supportedPurposeCodes.filter(
          purposeCode => purposeCode.code === contingency.selectedPurposeCode
        )?.[0]
      }
    }
    return populatePurposeOfPaymentDetails(
      dispatch,
      contingency,
      selectedPurposeOfCode
        ? selectedPurposeOfCode
        : selectedPurposeOfPaymentOption
    )
  }
  return true
}
